import { render, staticRenderFns } from "./ReplyOtherUserOpinionTab.vue?vue&type=template&id=5d5f4fc5&scoped=true&lang=pug"
import script from "./ReplyOtherUserOpinionTab.vue?vue&type=script&lang=ts"
export * from "./ReplyOtherUserOpinionTab.vue?vue&type=script&lang=ts"
import style0 from "./ReplyOtherUserOpinionTab.vue?vue&type=style&index=0&id=5d5f4fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f4fc5",
  null
  
)

export default component.exports